import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../service/loading.service';
// 1. IMPORTAMOS NUESTRO TOKEN
import { BYPASS_LOADING } from '../../../../../interceptors/interceptor-context';

export const loadingInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const loadingService = inject(LoadingService);

  // 2. AÑADIMOS LA CONDICIÓN
  // Si la petición tiene el token BYPASS_LOADING, la dejamos pasar sin mostrar el loader.
  if (req.context.get(BYPASS_LOADING) === true) {
    return next(req);
  }

  // Si no tiene el token, la lógica continúa como antes.
  loadingService.show();

  return next(req).pipe(
    finalize(() => {
      loadingService.hide();
    })
  );
};
